var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from 'react';
import { escapeRegex, interpolate, LocalizationContext } from '.';
function isFunction(val) {
    return typeof val === 'function';
}
var toTag = function (key, tag, suffix) {
    if (suffix === void 0) { suffix = ''; }
    return "" + tag.start + key + suffix + tag.end;
};
var nodeRegex = function (begin, end) {
    return new RegExp(escapeRegex(begin) + "(.*)" + escapeRegex(end), 'gi');
};
var hasKeys = function (obj) { return Object.keys(obj).length > 0; };
var contains = function (input, key) {
    var regexp = new RegExp(escapeRegex(key), 'gi');
    return !!input.match(regexp);
};
export var Text = function (_a) {
    var id = _a.id, _b = _a.interpolations, interpolations = _b === void 0 ? {} : _b, tagOverride = _a.tag, suffixOverride = _a.suffix;
    var context = React.useContext(LocalizationContext);
    var tag = tagOverride !== null && tagOverride !== void 0 ? tagOverride : context.tag;
    var suffix = suffixOverride !== null && suffixOverride !== void 0 ? suffixOverride : context.suffix;
    var string = context.translations[id];
    if (!string) {
        console.error("Couldn't find '" + id + "' in the translations table"); // eslint-disable-line no-console
        return null;
    }
    if (hasKeys(interpolations)) {
        var initValue = { single: {}, pair: {} };
        var _c = Object.entries(interpolations).reduce(function (acc, _a) {
            var _b = __read(_a, 2), key = _b[0], value = _b[1];
            if (contains(string, toTag(key, tag))) {
                acc.single[key] = value;
            }
            else if (contains(string, toTag(key, tag, suffix.begin)) &&
                contains(string, toTag(key, tag, suffix.end)) &&
                isFunction(value) // very weak check
            ) {
                acc.pair[key] = value;
            }
            return acc;
        }, initValue), pair_1 = _c.pair, single_1 = _c.single;
        var pairInterpolations_1 = {};
        Object.keys(pair_1).forEach(function (key) {
            var regexp = nodeRegex(toTag("" + key + suffix.begin, tag), toTag("" + key + suffix.end, tag));
            var matches = regexp.exec(string);
            if (matches === null)
                return;
            var _a = __read(matches, 2), fullMatch = _a[0], insideMatch = _a[1];
            var uniqueKey = key + "-pair";
            var match = hasKeys(single_1) ? interpolate(insideMatch, single_1, tag) : insideMatch;
            pairInterpolations_1[uniqueKey] = pair_1[key](match, 0); // Only 1 pair supported
            string = string.replace(fullMatch, "" + tag.start + uniqueKey + tag.end);
        });
        return (React.createElement(React.Fragment, null, interpolate(string, __assign(__assign({}, single_1), pairInterpolations_1), tag)));
    }
    else {
        return React.createElement(React.Fragment, null, string);
    }
};
//# sourceMappingURL=text.js.map